import React, { useEffect, useState } from 'react';
import SideNavLayout from '../../customsidenav/sidenavlayout';
import axios from 'axios';
import api from '../../api/api';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import { getPracticeId } from '../../config/practice';

const RpmAnalytics = () => {
  // State to store fetched data
  const [analyticsData, setAnalyticsData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const practiseid = getPracticeId();

  // Function to fetch RPM analytics data
  const fetchRpmData = async () => {
    try {
      const response = await api.get(`/v1/${practiseid}/rpm_analytics/fetch_rpm_counts`);
      if (response.status === 200) {
        setAnalyticsData(response.data);
      } else {
        setError('Failed to fetch data');
      }
    } catch (error) {
      setError('Error fetching data');
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch data when the component mounts
  useEffect(() => {
    fetchRpmData();
  }, []);

  return (
    <SideNavLayout>
      <div className="p-4">
        <div className='flex justify-between w-full'>
          <button className="btn mr-2" onClick={() => navigate(-1)}>
            <ArrowBackIosNewIcon style={{ width: '12px', marginBottom: '4px', marginRight: '5px' }} /> Back
          </button>
        </div>
        <div className='text-lg font-bold mb-2'>
          RPM
        </div>

        {/* Show loading message under the RPM title if data is still loading */}
        {isLoading && <div className="text-xl text-gray-500"><div className="text-center text-orange-500 mb-4">
          <HourglassBottomIcon
  className="text-orange-500 rotatingIcon"
/>

    Please wait...
</div>
</div>}

        {/* If there is an error, display error message */}
        {error && <div className="text-red-500">{error}</div>}

        {/* If there is no data or if data is available, show the stats */}
        {!isLoading && !error && analyticsData && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-2">Total RPM Count</h3>
              <p className="text-2xl">{analyticsData.TotalCount}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-2">Today RPM Enroll</h3>
              <p className="text-2xl">{analyticsData.TodaySignupCount}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-2">Last 7 Days Signups</h3>
              <p className="text-2xl">{analyticsData.LastSevenSignupCount}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-2">BPP Device Un-Assign</h3>
              <p className="text-2xl">{analyticsData.bppDeviceUnassign}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-2">WLM Device Unassigned</h3>
              <p className="text-2xl">{analyticsData.wlmDeviceUnassign}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-2">Total BPP Devices</h3>
              <p className="text-2xl">{analyticsData.TotalBppDevice}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-2">Assigned BPP Devices</h3>
              <p className="text-2xl">{analyticsData.assignedBppDevice}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-2">Total WLM Devices</h3>
              <p className="text-2xl">{analyticsData.TotalWlmDevice}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-2">Assigned WLM Devices</h3>
              <p className="text-2xl">{analyticsData.assignedWlmDevice}</p>
            </div>
          </div>
        )}

        {/* Show message when no data is available */}
        {!isLoading && !error && !analyticsData && (
          <div className="text-red-500">No data available</div>
        )}
        
      </div>
      <style jsx>{`
        @keyframes rotateIcon {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .rotatingIcon {
          animation: rotateIcon 1s linear infinite;
        }
      `}</style>
    </SideNavLayout>
  );
};

export default RpmAnalytics;
